import { Injectable } from '@angular/core'
import { Router } from '@angular/router'

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

                         phat = 'https://apiconsopanel.consolidada.com.py/api/'; //produccion
               //phat = 'http://192.168.98.8:8000/api/'; //pre-produccion
                       // phat = 'http://consopanelv3.local/api/'; // local

  constructor(private router: Router) { }

  getApiPhat(): string{
    return  this.phat;
  }


  redirectLogin(){
    this.router.navigate(['']);
  }
}
